import { useLocation } from 'react-router';

export const useCurrentPath = () => {
  const location = useLocation();

  return location.pathname + location.search;
};
